import {Component, OnInit} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {VeritiyPricesTableRowModel} from '../../models/verity-prices-table-row-model';
import {DefaultExporterComponent} from '../../../utils/components/export/DefaultExporterComponent';
import {UnitPriceModel} from '../../../utils/models/unit-price-model';
import {VerityPriceTableStates} from '../verity-prices-table/verity-prices-table-states';
import {Utils} from '../../../utils/services/utils';

@Component({
  selector: 'app-unit-prices',
  templateUrl: './unit-prices.component.html',
  styleUrls: ['./unit-prices.component.css']
})
export class UnitPricesComponent extends DefaultExporterComponent implements OnInit {

  tableColumns: VeritiyPricesTableRowModel[] = [
    new VeritiyPricesTableRowModel(1, 100, 'Country', 'Country_name', true, 'left', true),
    new VeritiyPricesTableRowModel(2, 100, 'Company', 'Manufacturer', true, 'left', true),
    new VeritiyPricesTableRowModel(3, 110, 'Likely Parallel Trade', 'parallel_trade', true, 'left', true),
    new VeritiyPricesTableRowModel(4, 100, 'Brand', 'International_Brand_Name', true, 'left', true),
    new VeritiyPricesTableRowModel(5, 100, 'INN', 'INN', true, 'left', true),
    new VeritiyPricesTableRowModel(6, 100, 'ATC', 'ATC', true, 'left', true),
    new VeritiyPricesTableRowModel(7, 100, 'Strength', 'Strength', true, 'left', true),
    new VeritiyPricesTableRowModel(8, 100, 'Form', 'Form', true, 'left', true),
    new VeritiyPricesTableRowModel(9, 100, 'Pack size', 'Package_size', true, 'right'),
    new VeritiyPricesTableRowModel(10, 100, 'Package', 'Package_type', true, 'left'),
    new VeritiyPricesTableRowModel(11, 100, 'SKU Details', 'SKU_detail', true, 'left'),
    new VeritiyPricesTableRowModel(12, 100, 'Currency', 'Loc_Currency', true, 'left'),
    new VeritiyPricesTableRowModel(13, 100, 'Ex-Factory list price/standard unit', 'ExF_excl_VAT_unit', true, 'right'),
    new VeritiyPricesTableRowModel(14, 100, 'ExFactory list price flag', 'ExF_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(15, 130, 'Wholesale price/standard unit', 'WHS_excl_VAT_unit', true, 'right'),
    new VeritiyPricesTableRowModel(16, 100, 'Wholesale price flag', 'WHS_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(17, 130, 'Pharmacy price without VAT/standard unit', 'Ret_excl_VAT_unit', true, 'right'),
    new VeritiyPricesTableRowModel(18, 130, 'Pharmacy price without VAT flag', 'Ret_excl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(19, 110, 'Pharmacy price with VAT/standard unit', 'Ret_incl_VAT_unit', true, 'right'),
    new VeritiyPricesTableRowModel(20, 110, 'Pharmacy price with VAT flag', 'Ret_incl_VAT_flag', true, 'left'),
    new VeritiyPricesTableRowModel(21, 130, 'Last found date', 'last_found_dttm', true, 'right'),
    new VeritiyPricesTableRowModel(30, 100, 'SKU_id', 'SKU_id', true, 'left'),
    new VeritiyPricesTableRowModel(31, 100, 'Loc_Product_cd', 'Loc_Product_cd', true, 'left'),
  ];

  selection = new SelectionModel<UnitPriceModel>(true, []);
  dataLoaded = false;

  public tableInput: UnitPriceModel[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.http.post('/getdatapoints/', {})
      .subscribe((response: UnitPriceModel[]) => {
        this.tableInput = this.calculateUnitPrices(response);

        this.dataLoaded = true;
      }, error => {
        this.dataLoaded = true;
      });
  }

  calculateUnitPrices(tableInput: UnitPriceModel[]) {
    tableInput.forEach(row => {
      const strength: number = Utils.extractStrengthFromString(row['Strength']);

      const units = Number(row['Package_size']);

      const ExF_excl_VAT_Number = Number(row['ExF_excl_VAT']) / strength / units;
      const WHS_excl_VAT_Number = Number(row['WHS_excl_VAT']) / strength / units;
      const Ret_excl_VAT_Number = Number(row['Ret_excl_VAT']) / strength / units;
      const Ret_incl_VAT_Number = Number(row['Ret_incl_VAT']) / strength / units;

      row['ExF_excl_VAT_unit'] = String(ExF_excl_VAT_Number);
      row['WHS_excl_VAT_unit'] = String(WHS_excl_VAT_Number);
      row['Ret_excl_VAT_unit'] = String(Ret_excl_VAT_Number);
      row['Ret_incl_VAT_unit'] = String(Ret_incl_VAT_Number);

      row['Strength_and_form'] = row['Strength'] + ' ' + row['Form'];

    });

    return tableInput;
  }

  onTableViewChange($event) {
    switch ($event) {
      case VerityPriceTableStates.EXTERNAL:
        this.showColumns(['ExF_excl_VAT_unit', 'ExF_excl_VAT_flag', 'WHS_excl_VAT_unit', 'WHS_excl_VAT_flag', 'Ret_excl_VAT_unit',
          'Ret_excl_VAT_flag', 'Ret_incl_VAT_unit', 'Ret_incl_VAT_flag']);
        break;

      case VerityPriceTableStates.INTERNAL:
        this.showColumns(['ExF_excl_VAT_unit', 'ExF_excl_VAT_flag']);
        this.hideColumns(['WHS_excl_VAT_unit', 'WHS_excl_VAT_flag', 'Ret_excl_VAT_unit',
          'Ret_excl_VAT_flag', 'Ret_incl_VAT_unit', 'Ret_incl_VAT_flag']);
        break;
    }
  }

  private showColumns(keys: Array<string>) {
    keys.forEach(key => this.changeColumnVisibility(key, true));
  }

  private hideColumns(keys: Array<string>) {
    keys.forEach(key => this.changeColumnVisibility(key, false));
  }

  private changeColumnVisibility(key: string, visible: boolean) {
    this.tableColumns.find(column => column.key === key).visible = visible;
  }
}
